import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ObserversModule } from '@angular/cdk/observers';

import { EuiTableComponent } from './eui-table.component';
import { EuiIconModule } from '../atoms';
import { EuiTableSortableColComponent } from './sortable-col/eui-table-sortable-col.component';
import { EuiTablePaginatorComponent } from './paginator/eui-table-paginator.component';
import { EuiListModule } from '../eui-list';
import { EuiDropdownModule } from '../eui-dropdown';
import { EuiButtonModule } from '../eui-button';
import { EuiTableFilterComponent } from './filter/eui-table-filter.component';
import { EuiTableSelectableRowComponent } from './selectable-row/eui-table-selectable-row.component';
import { EuiTableSelectableHeaderComponent } from './selectable-header/eui-table-selectable-header.component';
import { EuiTableExpandableRowComponent } from './expandable-row/eui-table-expandable-row.component';
import { EuiTableHighlightFilterPipe } from './pipes/eui-table-highlight-filter.pipe';
import { EuiTemplateDirectiveModule } from '../../directives';

@NgModule({
    imports: [
        CommonModule,
        EuiIconModule,
        EuiListModule,
        EuiDropdownModule,
        EuiButtonModule,
        ReactiveFormsModule,
        TranslateModule,
        ObserversModule,
        EuiTemplateDirectiveModule,
    ],
    declarations: [
        EuiTableComponent,
        EuiTableSortableColComponent,
        EuiTablePaginatorComponent,
        EuiTableFilterComponent,
        EuiTableSelectableRowComponent,
        EuiTableSelectableHeaderComponent,
        EuiTableExpandableRowComponent,
        EuiTableHighlightFilterPipe,
    ],
    exports: [
        EuiTableComponent,
        EuiTableSortableColComponent,
        EuiTablePaginatorComponent,
        EuiTableFilterComponent,
        EuiTableSelectableRowComponent,
        EuiTableSelectableHeaderComponent,
        EuiTableExpandableRowComponent,
        EuiTableHighlightFilterPipe,
    ],
})
export class EuiTableModule { }
